import { getObjectByIdApi, putUpdateObjectListByPropertyValueArrayApi } from "api/general";
import { setCurrentAgendaList } from "stores/meeting";
import Swal from "sweetalert2";
import config, { rolePriority, titleOrder, voteResultType } from '../../config';
import { DECISION, MEETINGS, UNITS } from "./constants/customConstant";
import { USE_IMAGE_PLACEHOLDERS } from "./constants/paths";
import { updateMeetingAfterUserOperation } from "./meetingReduxHelpers";


export const getAssetPath = (url, size) => {
    if (USE_IMAGE_PLACEHOLDERS) {
        return `https://via.placeholder.com/${size}.png`;
    }

    return url;
};


export const getProfileImage = (profileImageUrl) => {

    return process.env.REACT_APP_USER_AUTH_URL + profileImageUrl;

};

export const createReportFileName = (filename, meeting) => {

    return filename + meeting.inst + "-" + meeting.meetingNo;


};


export const swal_success = (title, timer = 1500) => {
    Swal.fire({
        position: 'center',
        icon: 'success',
        title,
        showConfirmButton: false,
        timer
    });
}

export const swal_error = (title, timer = 1500) => {
    Swal.fire({
        position: "center",
        icon: "error",
        title,
        showConfirmButton: false,
        timer,
    })
}
export const swal_warning = (title, timer = 1500) => {
    Swal.fire({
        position: 'center',
        icon: 'warning',
        title,
        showConfirmButton: false,
        timer
    });
}

export function getUserExName(user) {

    return user === undefined || user === null ? "adSoyad" : (user.name[0] + '. ' + user.surname);

}


export const getAxiosConfigUserToken = () => {
    const token = localStorage.getItem("token");
    if (!token) {
        console.warn("Token bulunamadı! Lütfen giriş yaptığınızdan emin olun.");
        return {};
    }
    const configAxios = {
        headers: { Authorization: `Bearer ${token}` }
    }
    return configAxios;
}

export function getDateStringYYYYMMDD(date, addedTimeString = "00:00:01") {

    const d = new Date(date);
    return `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${d.getDate() + 1 < 9 ? ("0" + (d.getDate())).slice(-2) : d.getDate()} ${addedTimeString}`

}
export function getUserFullName(user) {

    return user === undefined || user === null ? "Bilinmeyen Kullanıcı" : (user.title !== "" ? user.title + ' ' + user.name + ' ' + user.surname : user.name + ' ' + user.surname);

}
export function getUserFullName2(title, name, surname) {

    const title_ = (title !== "" && title !== undefined && title !== null) ? title : '';
    const name_ = (name !== "" && name !== undefined && title !== null) ? name : '';
    const surname_ = (surname !== "" && surname !== undefined && title !== null) ? surname : '';
    const result = title_ + ' ' + name_ + ' ' + surname_;
    if (result === "  ") {
        return "Bilinmeyen Kullanıcı";
    }
    return result;
}

export function getLocaleDateTime(date) {

    return new Date(date).toLocaleString("tr")

}

export function getShortLocaleDateTime(date) {

    return new Date(date).toLocaleDateString("tr");

}

export const isRoleCheckList = (userRoles, roleList) => {
    return roleList.some(roleId => userRoles.some(x => x.id === roleId))
}


export const isEditable = (pageType) => {

    let result = false;
    if (pageType && (pageType === "1" || pageType === "3")) {

        result = true;
    }
    return result;
}



// SİLLLLL ????
// export const getAuthorizedInstFromRoles = (userRoles) => {
//     // Yardımcı fonksiyon: role.inst değerini dizi veya string fark etmeksizin sete ekler.
//     const addInstToSet = (set, role) => {
//         if (!role.inst) return;
//         if (Array.isArray(role.inst)) {
//             role.inst.forEach(inst => set.add(inst));
//         } else {
//             set.add(role.inst);
//         }
//     };

//     let hasRole1 = false;
//     userRoles.forEach(role => {
//         const currentRoleId = role.roleId || role.id;
//         if (currentRoleId === 1) {
//             hasRole1 = true;
//         }
//     });

//     if (hasRole1) {
//         const insts = config.institutions.map(x => x.inst);
//         return {
//             management: {
//                 full: insts,
//                 partial: insts
//             },
//             read: insts
//         };
//     }

//     // Rol "1" yoksa, rollere göre ayrı ayrı toplayalım:
//     const managementFullSet = new Set(); // 373 ve 370'dan inst'ler
//     const managementPartialUnitIds = []; // 369'dan customId'ler (direkt dizi olarak döneceğiz)
//     const readSet = new Set(); // 371 ve 368'den inst'ler

//     // İlk geçiş: 373, 370, 371 ve 368'dan inst'leri ekle.
//     userRoles.forEach(role => {
//         const currentRoleId = role.roleId || role.id;
//         if (!role.inst) return;
//         if (currentRoleId === 373 || currentRoleId === 370) {
//             addInstToSet(managementFullSet, role);
//         } else if (currentRoleId === 371 || currentRoleId === 368) {
//             addInstToSet(readSet, role);
//         }
//     });

//     // İkinci geçiş: 369 için, önce inst kontrolü yapıp,
//     // eğer bu inst management full'da yoksa customId'yi ekle (0 veya undefined olanlar hariç).
//     userRoles.forEach(role => {
//         const currentRoleId = role.roleId || role.id;
//         if (currentRoleId === 369) {
//             if (!role.inst) return;
//             // Eğer rol 369'daki inst, managementFullSet'te varsa eklemiyoruz.
//             if (managementFullSet.has(role.inst)) return;
//             if (role.customId !== undefined && role.customId !== 0 && !managementPartialUnitIds.includes(role.customId)) {
//                 managementPartialUnitIds.push(role.customId);
//             }
//         }

//         if (currentRoleId === 372) {
//             if (!role.inst) return;
//             // Eğer rol 369'daki inst, managementFullSet'te varsa eklemiyoruz.
//             if (managementFullSet.has(role.inst)) return;
//             if (role.customId !== undefined && role.customId !== 0 && !managementPartialUnitIds.includes(role.customId)) {
//                 managementPartialUnitIds.push(role.customId);
//             }
//         }
//     });


//     return {
//         management: {
//             full: Array.from(managementFullSet),
//             partial: managementPartialUnitIds
//         },
//         read: Array.from(readSet)
//     };
// };

export const filterManagementUnits = (units, auth) => {
    const fullInsts = auth.management.full;       // Örnek: ["AKM", "YK", "TDK"]
    const partialIds = auth.management.partial;     // Örnek: [105, 106, 22]

    const fullUnits = units.filter(unit => fullInsts.includes(unit.inst));
    const partialUnits = units.filter(unit => partialIds.includes(unit.id));

    const combined = [...fullUnits];
    partialUnits.forEach(unit => {
        if (!combined.some(u => u.id === unit.id)) {
            combined.push(unit);
        }
    });
    return combined;
};

export const filterManagementUnitsV2 = (units, auth) => {
    const fullInsts = auth.management.full;       // Örnek: ["AKM", "YK", "TDK"]
    const partialIds = auth.management.partial;     // Örnek: [105, 106, 22]

    const fullUnits = units.filter(unit => fullInsts.includes(unit.inst));
    const partialUnits = units.filter(unit => partialIds.includes(unit.unitId));

    const combined = [...fullUnits];
    partialUnits.forEach(unit => {
        if (!combined.some(u => u.id === unit.id)) {
            combined.push(unit);
        }
    });
    return combined;
};



export const isRoleCheck = (roles, roleId) => {
    return roles.find(x => x.id === roleId) !== undefined
}

export const getInstColor = (instName) => {
    const found = config.institutions.find(item => item.inst === instName);
    return found ? found.color : 'gray';
};

export const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
    }
    return text;
};


export const downloadPDFFile = (file, fileName) => {

    const fileUrl = URL.createObjectURL(file);
    let a = document.createElement('a');
    a.href = fileUrl;
    a.download = fileName + '.pdf';
    a.click();
}
export const downloadWORDFile = (file, fileName) => {

    const fileUrl = URL.createObjectURL(file);
    let a = document.createElement('a');
    a.href = fileUrl;
    a.target = "_blank";
    a.download = fileName + '.docx';
    a.click();

}



// ORJ
// export const openPDFFile = (file) => {

//     const fileURL = URL.createObjectURL(file);
//     const pdfWindow = window.open();
//     console.log('file', file)
//     pdfWindow.location.href = fileURL;

// }

export const openPDFFile = (file) => {

    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    link.target = '_blank';
    // link.download = 'dosya.pdf'; // Eğer indirme yapmak isterseniz
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const getOpenFileFromFullPath = (fullPath) => {
    if (!fullPath) {
        alert("Rapor Bulunamadı");
        return;
    }
    const url = config.apiUrl + "/uploads" + fullPath;
    // Dosyanın mevcut olup olmadığını kontrol etmek için HEAD isteği gönderiyoruz
    fetch(url, { method: 'HEAD' })
        .then(response => {
            if (response.ok) {
                window.open(url, '_blank');
            } else {
                alert("Rapor Bulunamadı");
            }
        })
        .catch(error => {
            console.error("Dosya kontrolü sırasında hata oluştu:", error);
            alert("Rapor Bulunamadı");
        });
}


// nbey den aldıgim fonk
// export const getUploadFileFullPathDownload = (file, fileName) => {
//     //return config.apiUrl +"/uploads" + file.path + file.docId + file.ext;

//     console.log("file name ", fileName)
//     let a = document.createElement('a');
//     a.href = config.apiUrl + "/uploads/" + fileName;
//     a.href = config.apiUrl +"/uploads"+ file.path  +  file.docId + file.ext;
//     a.download = fileName !== undefined ? fileName : file.originalName  //  <IntlMessages id={"file.doctype."+file.docType} />;

//     a.target = "_blank";
//     a.click();

// }

export const getUploadFileFullPathDownload = (foldername, fileName, downloadName = "") => {

    let a = document.createElement('a');
    a.href = config.apiUrl + "/uploads" + "/" + foldername + "/" + fileName;
    a.download = downloadName !== "" ? downloadName : fileName;

    a.target = "_blank";
    a.click();

}

// bak !!!!
export const getDownloadFileName = (meeting, fileObj) => {
    const fileName = meeting.inst + meeting.meetingNo + "SayiliToplanti-" + fileObj.fileType + fileObj.ext;
    return fileName;
}

export function sortByProperty(array, property, order = 'asc') {
    return [...array].sort((a, b) => {
        return order === 'desc' ? b[property] - a[property] : a[property] - b[property];
    });
}
export function sortByDate(array, property, order = 'asc') {
    return order === 'desc' ? [...array].sort((a, b) => new Date(b[property]) - new Date(a[property])) : [...array].sort((a, b) => new Date(a[property]) - new Date(b[property]))
}
export const alphabeticSorting = (array, order = 'asc') => {
    return array.sort((a, b) => {
        return order === 'asc' ? a.name.localeCompare(b.name, 'tr') : b.name.localeCompare(a.name, 'tr');
    });
};

export function sortedMembers(memberList) {
    const normalizedTitleOrder = titleOrder.map(title => title.replace(/\s+/g, '').toLocaleLowerCase('tr'));
    const sortedMembers = [...memberList];

    const participantMembers = sortedMembers.filter(member => member.type === 2);
    const userMembers = sortedMembers.filter(member => member.type !== 2);

    participantMembers.sort((a, b) => {
        if (!a.user || !b.user) {
            return a.user ? -1 : 1;
        }

        const normalizedATitle = a.user.title.replace(/\s+/g, '').toLocaleLowerCase('tr');
        const normalizedBTitle = b.user.title.replace(/\s+/g, '').toLocaleLowerCase('tr');
        const aTitleIndex = normalizedTitleOrder.indexOf(normalizedATitle);
        const bTitleIndex = normalizedTitleOrder.indexOf(normalizedBTitle);

        // Eğer title listede yoksa, en sona yerleştirmek için büyük bir index atanır
        const adjustedATitleIndex = aTitleIndex === -1 ? normalizedTitleOrder.length : aTitleIndex;
        const adjustedBTitleIndex = bTitleIndex === -1 ? normalizedTitleOrder.length : bTitleIndex;

        if (adjustedATitleIndex !== adjustedBTitleIndex) {
            return adjustedATitleIndex - adjustedBTitleIndex;
        }

        const aFullName = (a.user.name + " " + a.user.surname).toLocaleLowerCase('tr');
        const bFullName = (b.user.name + " " + b.user.surname).toLocaleLowerCase('tr');

        return aFullName.localeCompare(bFullName, 'tr');
    });

    userMembers.sort((a, b) => {
        if (a.memberRole !== b.memberRole) {
            return (rolePriority[a.memberRole] || 99) - (rolePriority[b.memberRole] || 99);
        }

        if (!a.user || !b.user) {
            return a.user ? -1 : 1;
        }

        const normalizedATitle = a.user.title.replace(/\s+/g, '').toLocaleLowerCase('tr');
        const normalizedBTitle = b.user.title.replace(/\s+/g, '').toLocaleLowerCase('tr');
        const aTitleIndex = normalizedTitleOrder.indexOf(normalizedATitle);
        const bTitleIndex = normalizedTitleOrder.indexOf(normalizedBTitle);

        // Eğer title listede yoksa, en sona yerleştirmek için büyük bir index atanır
        const adjustedATitleIndex = aTitleIndex === -1 ? normalizedTitleOrder.length : aTitleIndex;
        const adjustedBTitleIndex = bTitleIndex === -1 ? normalizedTitleOrder.length : bTitleIndex;

        if (adjustedATitleIndex !== adjustedBTitleIndex) {
            return adjustedATitleIndex - adjustedBTitleIndex;
        }

        const aFullName = (a.user.name + " " + a.user.surname).toLocaleLowerCase('tr');
        const bFullName = (b.user.name + " " + b.user.surname).toLocaleLowerCase('tr');

        return aFullName.localeCompare(bFullName, 'tr');
    });

    return [...participantMembers, ...userMembers];
}

export const uniqueListById = (list) => {
    const uniqueMap = new Map();

    list.forEach((item) => {
        if (!uniqueMap.has(item.id)) {
            uniqueMap.set(item.id, item);
        }
    });

    return Array.from(uniqueMap.values());
};

export const uniqueListByPropertyName = (list, propertyName) => {
    const uniqueSet = new Set();

    list.forEach((item) => {
        uniqueSet.add(item[propertyName]);
    });

    return Array.from(uniqueSet);
};

// export function stripHTMLTags(str) {
//     if (typeof str === 'string') {
//         return str.replace(/<\/?[^>]+(>|$)/g, "");
//     }
//     return str;
// }

export function stripHTMLTags(str) {
    if (typeof str === 'string') {
        // Önce <br> etiketlerini newline karakterine çeviriyoruz:
        const withNewLines = str.replace(/<br\s*\/?>/gi, "\n");
        // Sonra kalan HTML etiketlerini kaldırıyoruz:
        return withNewLines.replace(/<\/?[^>]+(>|$)/g, "");
    }
    return str;
}


export const getFilteredAdminUserIds = async (data, userList) => {
    let uniqueIds = [...new Set(data.map(x => x.adminUserId))];
    let users = [];
    for (let i = 0; i < uniqueIds.length; i++) {
        let user = userList.find(x => x.id === uniqueIds[i]);
        if (user !== undefined) {
            users.push(user);
        }
    }
    return users;
}

//datadaki unitId ile yetkili olduğu unitıdleri getirir
export const getFilteredUnits = (list, units) => {

    return list.filter(item => units.map(unit => unit.id).includes(item.unitId));
}

export const getMeetingTitleByMeetingId = async (meetingId) => {

    const meeting = await getObjectByIdApi(MEETINGS, meetingId);
    const unitName = await getUnitInfo(meeting.unitId);
    const meetingName = meeting.inst + " - " + unitName + " " + meeting.meetingNo + " Sayılı Toplantı ";
    return meetingName;
}
export const getUnitInfo = async (unitId) => {

    let unitName = await getObjectByIdApi(UNITS, unitId);
    unitName = unitName !== undefined ? unitName.name : "Tanımsız Kurul/Kol/Komisyon"
    return unitName;
}

export const getMeetingTitleByMeeting = (meeting) => {
    const meetingName = meeting.inst + " - " + meeting.unit + " " + meeting.meetingNo + " Sayılı Toplantı ";
    return meetingName;
}

export const getMeetingTitleByMeetingWithDate = (meeting) => {
    const meetingName = meeting.inst + " - " + meeting.unit + " " + meeting.meetingNo + " Sayılı Toplantı - " + getLocaleDateWithTimeCustomV4("tr", meeting.pdate);
    return meetingName;
}

export const getMeetingTitleByMeetingInstUnit = (meeting) => {
    const meetingName = meeting.inst + " - " + meeting.unit;
    return meetingName;
}


export const getMeetingUsers = async (meetingId, userList, musers, type) => {



    const ids = musers.map(u => u.userId);
    // console.log('ids', ids)
    if (ids.length > 0) {

        musers.forEach(item => {
            const user = userList.find(x => x.id === item.userId)
            item.user = user;
        });
        if (type !== undefined && type === "user") {
            musers = musers.filter(x => x.type === 1) // üyeler
        } else if (type !== undefined && type === "participant") {
            musers = musers.filter(x => x.type === 2) // katılımcılar
        }
        musers = sortByProperty(musers, "indexNo");

    }

    return musers
}


export const getVoteStatus = async (meetingUsers, agendaVotes, userList, meeting = {}) => {

    const processedUsers = meetingUsers.map(item => {
        const userData = userList.find(u => u.id === item.userId);
        const voteObj = agendaVotes.find(vote => vote.userId === item.userId);
        return {
            ...item,
            user: userData,
            voteObj
        };
    });

    let acceptCount = 0, rejectCount = 0, unvotedCount = 0;
    processedUsers.forEach(user => {
        if (user.voteObj && (user.voteObj.vote === 1 || user.voteObj.vote === 2)) {
            if (user.voteObj.vote === 1) {
                acceptCount++;
            } else if (user.voteObj.vote === 2) {
                rejectCount++;
            }
        } else {
            unvotedCount++;
        }
    });

    const totalCount = processedUsers.length;
    const usedVotes = acceptCount + rejectCount;
    let voteResultTypeId = 0;

    if (usedVotes <= totalCount / 2) {
        voteResultTypeId = 1;
    } else if (acceptCount === rejectCount && usedVotes > 0) {
        voteResultTypeId = 2;
    } else {
        // Burada kullanılan oylar üzerinden oy birliği/çokluğu belirleniyor.
        if (acceptCount === usedVotes) {   // Tüm kullanılan oylar kabul ise
            voteResultTypeId = 3;
        } else if (rejectCount === usedVotes) {   // Tüm kullanılan oylar ret ise
            voteResultTypeId = 4;
        } else if (acceptCount > rejectCount) {   // Kullanılan oyların çoğunluğu kabul ise
            voteResultTypeId = 5;
        } else {   // Aksi durumda: Kullanılan oyların çoğunluğu ret ise
            voteResultTypeId = 6;
        }
    }

    const voteResultTypeObj = voteResultType.find(vote => vote.id === voteResultTypeId);


    let decisionReportText = voteResultTypeObj.decisionReportText;
    let text = voteResultTypeObj.text;

    if (meeting.statFinish === 0 && meeting.statVote === 1) {
        let voteStatusInfo = "(Oylama devam etmektedir.)"
        decisionReportText = decisionReportText + " " + voteStatusInfo;
        text = text + " " + voteStatusInfo;
    }

    const voteResultTypeObjFinal = {
        id: voteResultTypeObj.id,
        text: text,
        decisionReportText: decisionReportText
    }

    return { processedUsers, acceptCount, rejectCount, unvotedCount, voteResultType: voteResultTypeObjFinal };
};



export function groupDecisionsBySubject(decisions) {
    // Kararları subjectId bazında gruplandır
    const grouped = decisions.reduce((acc, decision) => {
        const subjectId = decision.subjectId;
        if (!acc[subjectId]) {
            acc[subjectId] = [];
        }
        acc[subjectId].push(decision);
        return acc;
    }, {});

    // grouped nesnesini diziye çevirip, her grubun ilk elemanının decisionNo'suna göre sıralayın
    const groups = Object.entries(grouped).sort(
        ([, agendasA], [, agendasB]) => agendasA[0].decisionNo - agendasB[0].decisionNo
    );

    return groups;
}


export const getGroupedListForDepartment = async (dataArray, subjectList) => {
    // Departman içerisindeki verileri subjectId'ye göre grupluyoruz            
    const grouped = dataArray.reduce((acc, item) => {
        const key = `${item.subjectId}`;
        if (!acc[key]) {
            acc[key] = {
                subjectName: getSubjectName(item.subjectId, subjectList),
                items: []
            };
        }
        acc[key].items.push(item);
        return acc;
    }, {});

    const sortedList = Object.entries(grouped)
        .map(([subjectId, group]) => ({ subjectId, ...group }))
        .sort((a, b) => a.items[0].decisionNo - b.items[0].decisionNo);

    // const voteInfo = await getDepartmentGroupVoteInfoFromMeetingId(dataArray[0].meetingId); /// bunu sonra ayarla !!!!

    sortedList.forEach((group) => {
        group.decisionCount = group.items.length;
        // Örnek olarak voteResultType id değerine göre sayım yapıyoruz:
        group.acceptCount = group.items.filter((item) => item.voteResultType.id === 3 || item.voteResultType.id === 5).length;
        group.rejectCount = group.items.filter((item) => item.voteResultType.id === 4 || item.voteResultType.id === 6).length;
        group.sameCount = group.items.filter((item) => item.voteResultType.id === 2).length;
        group.saltCount = group.items.filter((item) => item.voteResultType.id === 1).length;
    });
    return sortedList;
};
export function calculateCounts(agendas) {
    let decisionCount = 0;
    let acceptCount = 0;
    let rejectCount = 0;
    let sameCount = 0;
    let saltCount = 0;
    agendas.forEach(group => {

        decisionCount = agendas.length;
        acceptCount += group.voteResultType.id === 3 || group.voteResultType.id === 5;
        rejectCount += group.voteResultType.id === 4 || group.voteResultType.id === 6;
        sameCount += group.voteResultType.id === 2;
        saltCount += group.voteResultType.id === 1;
    });


    return { decisionCount, acceptCount, rejectCount, sameCount, saltCount };
}

export const getLocaleDateCustom = (locale, date1) => {
    const d1 = date1 === undefined ? new Date() : new Date(date1);
    locale = locale === undefined ? "tr" : locale;

    Date.prototype.monthNamesEn = [
        "January", "February", "March",
        "April", "May", "June",
        "July", "August", "September",
        "October", "November", "December"
    ];
    Date.prototype.monthNames = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
        "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
    ];
    Date.prototype.getMonthName = function (locale) {
        return locale === "tr" ? this.monthNames[this.getMonth()] : this.monthNamesEn[this.getMonth()];
    };
    return d1.toLocaleString(locale, { day: "numeric" }) + " " + d1.getMonthName(locale) + " " + d1.getFullYear();
}

export const getLocaleDateWithTimeCustom = (locale, date1) => {
    const d1 = date1 === undefined ? new Date() : new Date(date1);
    locale = locale === undefined ? "tr" : locale;

    Date.prototype.monthNamesEn = [
        "January", "February", "March",
        "April", "May", "June",
        "July", "August", "September",
        "October", "November", "December"
    ];
    Date.prototype.monthNames = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
        "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
    ];
    Date.prototype.getMonthName = function (locale) {
        return locale === "tr" ? this.monthNames[this.getMonth()] : this.monthNamesEn[this.getMonth()];
    };

    const hours = d1.getHours();
    const minutes = d1.getMinutes();
    const formattedTime = `${hours}.${minutes < 10 ? '0' + minutes : minutes}`;

    return d1.toLocaleString(locale, { day: "numeric" }) + " " + d1.getMonthName(locale) + " " + d1.getFullYear() + "/" + formattedTime;
}


export function getSubjectName(subjectId, subjectList) {

    return subjectId === undefined || subjectId === null ? "Tanımsız" : (subjectList.find(x => x.id === subjectId)?.name || "Tanımsız");
}


export function getUnitName(unitId, unitList) {
    return unitId === undefined || unitId === null ? "Tanımsız Kurul/Kol/Komisyon" : (unitList.find(x => x.id === unitId)?.name || "Tanımsız Kurul/Kol/Komisyon");
}

export const convertHtmlToString = (htmlValue) => {
    let result = ""
    try {
        result = htmlValue.replace(/<\/?[^>]+(>|$)/g, "");
        result = result.replace(/&.*;/g, '');
    } catch (error) {
        result = htmlValue
    }

    return result;
}

export const getLocaleDateWithTimeCustomV2 = (locale = 'tr', date1) => {
    // date1 belirtilmediyse mevcut tarihi, belirtilmişse geçerli tarihi kullanıyoruz
    const d1 = date1 === undefined ? new Date() : new Date(date1);

    // Gün ve ay değerlerini 2 haneli yapmak için kontrol ediyoruz
    const day = d1.getDate() < 10 ? '0' + d1.getDate() : d1.getDate();
    const month = (d1.getMonth() + 1) < 10 ? '0' + (d1.getMonth() + 1) : d1.getMonth() + 1;
    const year = d1.getFullYear();

    // Saat ve dakika değerlerini de 2 haneli olacak şekilde biçimlendiriyoruz
    const hours = d1.getHours() < 10 ? '0' + d1.getHours() : d1.getHours();
    const minutes = d1.getMinutes() < 10 ? '0' + d1.getMinutes() : d1.getMinutes();

    // İstenen format: dd/mm/yyyy - HH.mm
    return `${day}/${month}/${year} - ${hours}.${minutes}`;
};
// saatsiz
export const getLocaleDateWithTimeCustomV4 = (locale = 'tr', date1) => {
    // date1 belirtilmediyse mevcut tarihi, belirtilmişse geçerli tarihi kullanıyoruz
    const d1 = date1 === undefined ? new Date() : new Date(date1);

    // Gün ve ay değerlerini 2 haneli yapmak için kontrol ediyoruz
    const day = d1.getDate() < 10 ? '0' + d1.getDate() : d1.getDate();
    const month = (d1.getMonth() + 1) < 10 ? '0' + (d1.getMonth() + 1) : d1.getMonth() + 1;
    const year = d1.getFullYear();

    // Saat ve dakika değerlerini de 2 haneli olacak şekilde biçimlendiriyoruz
    const hours = d1.getHours() < 10 ? '0' + d1.getHours() : d1.getHours();
    const minutes = d1.getMinutes() < 10 ? '0' + d1.getMinutes() : d1.getMinutes();

    // İstenen format: dd/mm/yyyy - HH.mm
    return `${day}/${month}/${year}`;
};
export const getCustomLocaleDateTime = (locale = 'tr', date1) => {
    const d1 = date1 === undefined ? new Date() : new Date(date1);

    const hours = d1.getHours() < 10 ? '0' + d1.getHours() : d1.getHours();
    const minutes = d1.getMinutes() < 10 ? '0' + d1.getMinutes() : d1.getMinutes();

    return `${hours}.${minutes}`;
};

export const getCustomLocaleDate = (locale = 'tr', date1) => {
    const d1 = date1 === undefined ? new Date() : new Date(date1);

    const day = d1.getDate() < 10 ? '0' + d1.getDate() : d1.getDate();
    const month = (d1.getMonth() + 1) < 10 ? '0' + (d1.getMonth() + 1) : d1.getMonth() + 1;
    const year = d1.getFullYear();
    return `${day}/${month}/${year}`;
};


export const chunkData = (data, chunkSize) => {
    const result = [];
    for (let i = 0; i < data.length; i += chunkSize) {
        result.push(data.slice(i, i + chunkSize));
    }
    return result;
};

export const sortMeetingListByPdateDesc = (list) => {
    return [...list].sort((a, b) => new Date(b.pdate) - new Date(a.pdate));
};

export function groupByPropertyName(list, property) {
    return list.reduce((groups, item) => {
        const key = item[property];
        if (!groups[key]) {
            groups[key] = [];
        }
        groups[key].push(item);
        return groups;
    }, {});
}





export const groupAgendasByDepartment = (agendaList) => {
    const validDepartments = ["YK", "ATAM", "AKM", "TDK", "TTK"];
    const getDeptKey = (deptStr) => {
        let deps = deptStr.split(",").map(s => s.trim());
        let filtered = deps.filter(d => validDepartments.includes(d));
        return filtered.join(", ");
    };

    const sorted = [...agendaList].sort((a, b) => a.decisionNo - b.decisionNo);
    const deptGroups = sorted.reduce((acc, agenda) => {
        const key = getDeptKey(agenda.department);
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(agenda);
        return acc;
    }, {});

    return Object.entries(deptGroups).sort((a, b) => {
        const aMinDecisionNo = Math.min(...a[1].map(agenda => agenda.decisionNo));
        const bMinDecisionNo = Math.min(...b[1].map(agenda => agenda.decisionNo));
        return aMinDecisionNo - bMinDecisionNo;
    });
};


export const subjectGroupsFromAgendas = (agendas) => {
    return Object.entries(
        agendas.reduce((acc, agenda) => {
            const subj = agenda.subjectId;
            if (!acc[subj]) acc[subj] = [];
            acc[subj].push(agenda);
            return acc;
        }, {})
    ).sort((a, b) => a[1][0].decisionNo - b[1][0].decisionNo);
};

export const calculateNewDecisionNo = (currentAgendaList, agendas, department) => {

    if (agendas.length > 0) {
        const lastDecisionNo = Math.max(...agendas.map(a => Number(a.decisionNo)));
        return lastDecisionNo + 1;
    } else {

        const deptAgendas = currentAgendaList.filter(a => a.department === department && a.supp !== 'Evet');
        if (deptAgendas.length > 0) {
            return Math.max(...deptAgendas.map(a => Number(a.decisionNo))) + 1;
        } else {
            const nonExtraAgendas = currentAgendaList.filter(a => a.supp !== 'Evet');
            return nonExtraAgendas.length > 0
                ? Math.max(...nonExtraAgendas.map(a => Number(a.decisionNo))) + 1
                : 1;
        }
    }
};



export const updateSortedAgendaList = async (agendaList, type, newAgenda = [], swalFalg = false) => async (dispatch, getState) => {
    let updatedList = agendaList.map(item => ({ ...item }));
    const extraAgendas = updatedList.filter(item => item.supp === 'Evet');
    updatedList = updatedList.filter(item => item.supp !== 'Evet');

    if (type === "index") {
        updatedList = updatedList.map((item, idx) => ({
            ...item,
            decisionNo: idx + 1,
        }));
    }
    else if (type === "change") {
        updatedList = updatedList.filter(a => a.id !== newAgenda.id);

        if (newAgenda.supp !== 'Evet') {
            const idx = newAgenda.decisionNo - 1;
            updatedList.splice(idx, 0, newAgenda);
        } else {
            // Ek gündemlerde de normal gündemlerdeki gibi (department/subject)
            // grupla yerleştirme mantığını uygula
            // mevcut referansı koruyarak (const) filtre etkisini uygulamak için in-place sil
            for (let i = extraAgendas.length - 1; i >= 0; i--) {
                if (extraAgendas[i].id === newAgenda.id) {
                    extraAgendas.splice(i, 1);
                }
            }

            const getDeptKey = deptStr => {
                const validDepartments = ["YK", "ATAM", "AKM", "TDK", "TTK"];
                return deptStr
                    .split(",")
                    .map(s => s.trim())
                    .filter(d => validDepartments.includes(d))
                    .join(", ");
            };

            const sameSubjectGroup = extraAgendas.filter(
                item =>
                    item.subjectId === newAgenda.subjectId &&
                    getDeptKey(item.department) === getDeptKey(newAgenda.department)
            );

            let insertIndex;
            if (sameSubjectGroup.length > 0) {
                const lastRecord = sameSubjectGroup[sameSubjectGroup.length - 1];
                const lastIndex = extraAgendas.findIndex(item => item.id === lastRecord.id);
                insertIndex = lastIndex + 1;
            } else {
                const sameDeptGroup = extraAgendas.filter(
                    item => getDeptKey(item.department) === getDeptKey(newAgenda.department)
                );
                if (sameDeptGroup.length > 0) {
                    const lastRecord = sameDeptGroup[sameDeptGroup.length - 1];
                    const lastIndex = extraAgendas.findIndex(item => item.id === lastRecord.id);
                    insertIndex = lastIndex + 1;
                } else {
                    insertIndex = extraAgendas.length;
                }
            }

            extraAgendas.splice(insertIndex, 0, newAgenda);
        }

        for (let i = 0; i < updatedList.length; i++) {
            updatedList[i].decisionNo = i + 1;
        }
    }
    else if (type === "update") {
        updatedList = updatedList.filter(item => item.id !== newAgenda.id);
        if (newAgenda.supp === 'Evet') {
            // Ek gündemlerde de normal gündemlerdeki gibi (department/subject)
            // grupla yerleştirme mantığını uygula
            // mevcut referansı koruyarak (const) filtre etkisini uygulamak için in-place sil
            for (let i = extraAgendas.length - 1; i >= 0; i--) {
                if (extraAgendas[i].id === newAgenda.id) {
                    extraAgendas.splice(i, 1);
                }
            }

            const getDeptKey = deptStr => {
                const validDepartments = ["YK", "ATAM", "AKM", "TDK", "TTK"];
                return deptStr
                    .split(",")
                    .map(s => s.trim())
                    .filter(d => validDepartments.includes(d))
                    .join(", ");
            };

            const sameSubjectGroup = extraAgendas.filter(
                item =>
                    item.subjectId === newAgenda.subjectId &&
                    getDeptKey(item.department) === getDeptKey(newAgenda.department)
            );

            let insertIndex;
            if (sameSubjectGroup.length > 0) {
                const lastRecord = sameSubjectGroup[sameSubjectGroup.length - 1];
                const lastIndex = extraAgendas.findIndex(item => item.id === lastRecord.id);
                insertIndex = lastIndex + 1;
            } else {
                const sameDeptGroup = extraAgendas.filter(
                    item => getDeptKey(item.department) === getDeptKey(newAgenda.department)
                );
                if (sameDeptGroup.length > 0) {
                    const lastRecord = sameDeptGroup[sameDeptGroup.length - 1];
                    const lastIndex = extraAgendas.findIndex(item => item.id === lastRecord.id);
                    insertIndex = lastIndex + 1;
                } else {
                    insertIndex = extraAgendas.length;
                }
            }

            extraAgendas.splice(insertIndex, 0, newAgenda);
        } else {
            const getDeptKey = deptStr => {
                const validDepartments = ["YK", "ATAM", "AKM", "TDK", "TTK"];
                return deptStr
                    .split(",")
                    .map(s => s.trim())
                    .filter(d => validDepartments.includes(d))
                    .join(", ");
            };

            const sameSubjectGroup = updatedList.filter(
                item =>
                    item.subjectId === newAgenda.subjectId &&
                    getDeptKey(item.department) === getDeptKey(newAgenda.department)
            );

            let insertIndex;
            if (sameSubjectGroup.length > 0) {
                const lastRecord = sameSubjectGroup[sameSubjectGroup.length - 1];
                const lastIndex = updatedList.findIndex(item => item.id === lastRecord.id);
                insertIndex = lastIndex + 1;
            } else {
                const sameDeptGroup = updatedList.filter(
                    item => getDeptKey(item.department) === getDeptKey(newAgenda.department)
                );
                if (sameDeptGroup.length > 0) {
                    const lastRecord = sameDeptGroup[sameDeptGroup.length - 1];
                    const lastIndex = updatedList.findIndex(item => item.id === lastRecord.id);
                    insertIndex = lastIndex + 1;
                } else {
                    insertIndex = updatedList.length;
                }
            }

            updatedList.splice(insertIndex, 0, newAgenda);
            updatedList = updatedList.map((item, idx) => ({ ...item, decisionNo: idx + 1 }));
        }
    } else if (type === "updateV2") {
        if (newAgenda.supp === 'Evet') {
            const exIdx = extraAgendas.findIndex(a => a.id === newAgenda.id);
            console.log("exIdx", exIdx);
            if (exIdx >= 0) extraAgendas[exIdx] = newAgenda;
            else extraAgendas.push(newAgenda);
        } else {
            updatedList = updatedList.filter(item => item.id !== newAgenda.id);
            let insertIndex = updatedList.findIndex(item => item.decisionNo > newAgenda.decisionNo);
            if (insertIndex === -1) insertIndex = updatedList.length;
            updatedList.splice(insertIndex, 0, newAgenda);
        }
    }

    updatedList = [
        ...updatedList,
        ...extraAgendas
    ].map((item, idx) => ({ ...item, decisionNo: idx + 1 }));

    const objectList = updatedList.map(({ id, decisionNo }) => ({ id, decisionNo }));

    const result = await putUpdateObjectListByPropertyValueArrayApi(DECISION, "decisionNo", objectList);

    if (result.status) {
        dispatch(setCurrentAgendaList(updatedList));

        const state = getState();
        const currentMeeting = state.meeting.currentMeeting;
        const authUser = state.auth.authUser;
        const allMeetingList = state.meeting.allMeetingList;
        const allMMList = state.meeting.allMMList;




        if (authUser && currentMeeting && authUser.id !== currentMeeting.adminUserId) {
            await updateMeetingAfterUserOperation(
                currentMeeting,
                authUser,
                dispatch,
                allMeetingList,
                allMMList

            );
        }




        if (swalFalg) {
            Swal.close();
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'İşlem başarılı',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                    container: 'swal-container-custom'
                },
            });
        }
    }
};





export function transformGroups(groups, lookupFn = (id) => id) {
    return groups.map(([id, items]) => ({
        name: lookupFn(id),
        count: items.length,
    }));
}

export const getManagementReadAllUnitsInsts = (unitList, allAuthorizedUnits, allReadAuthorizedUnits) => {
    const filtered2 = [...allAuthorizedUnits, ...allReadAuthorizedUnits];
    const combinedUnits = [...filtered2].reduce((acc, unit) => {
        if (!acc.some(existingUnit => existingUnit.id === unit.id)) {
            acc.push(unit);
        }
        return acc;
    }, []);

    const units = combinedUnits;
    const insts = Array.from(new Set(units.map(unit => unit.inst)));

    return { units, insts };
};

export const getMergedAuthorizedInsts = (allAuthorizedInsts, allReadAuthorizedInsts) => {
    const readInstsWithoutYk = allReadAuthorizedInsts.filter(
        (inst) => inst?.toUpperCase() !== "YK"
    );
    return Array.from(new Set([...allAuthorizedInsts, ...readInstsWithoutYk]));
};

export const getMergedAuthorizedUnits = (allAuthorizedUnits, allReadAuthorizedUnits) => {
    const readUnitsWithoutYk = allReadAuthorizedUnits.filter(
        (unit) => unit.inst?.toUpperCase() !== "YK"
    );
    const unitMap = new Map();
    [...allAuthorizedUnits, ...readUnitsWithoutYk].forEach((unit) => {
        unitMap.set(unit.id, unit);
    });
    return Array.from(unitMap.values());
};



export const months = [
    { number: 1, monthText: "Ocak", monthTextEx: "Oca" },
    { number: 2, monthText: "Şubat", monthTextEx: "Şub" },
    { number: 3, monthText: "Mart", monthTextEx: "Mar" },
    { number: 4, monthText: "Nisan", monthTextEx: "Nis" },
    { number: 5, monthText: "Mayıs", monthTextEx: "May" },
    { number: 6, monthText: "Haziran", monthTextEx: "Haz" },
    { number: 7, monthText: "Temmuz", monthTextEx: "Tem" },
    { number: 8, monthText: "Ağustos", monthTextEx: "Ağu" },
    { number: 9, monthText: "Eylül", monthTextEx: "Eyl" },
    { number: 10, monthText: "Ekim", monthTextEx: "Eki" },
    { number: 11, monthText: "Kasım", monthTextEx: "Kas" },
    { number: 12, monthText: "Aralık", monthTextEx: "Ara" },
];


export const getMonthName = (monthNumber) => {
    const found = months.find(m => m.number === monthNumber);
    return found ? found.monthText : '';
};

export const groupDataByYearAndMonth = (data) => {
    const grouped = {};
    data.forEach(item => {
        const key = `${item.year} ${getMonthName(item.month)}`;
        if (!grouped[key]) {
            grouped[key] = [];
        }
        grouped[key].push(item);
    });
    return grouped;
};

export const overallTotal = (data) => data.reduce((acc, curr) => {
    acc.attended += Number(curr.attendedCount) || 0;
    acc.notAttended += Number(curr.notAttendedCount) || 0;
    acc.total += Number(curr.totalMeetingCount) || 0;
    return acc;
}, { attended: 0, notAttended: 0, total: 0 });



export const canViewSecretFiles = (agenda, authUser) => {

    if (agenda.secret !== "Evet") {
        return true;
    }

    const userRoles = authUser?.userRoles || [];

    const hasRequiredRole = userRoles.some(role => [1, 370, 373].includes(role.id));

    if (hasRequiredRole) {
        return true;
    }
    const role372 = userRoles.find(role => role.id === 372);
    if (role372) {

        if (role372.customId === Number(11)) {
            return true;
        } else {
            return false;
        }

    }

    return hasRequiredRole;
};


export const projeEsgudumMangList = (userRoles, list, idField = "unitId") => {
    if (isRoleCheckList(userRoles, [375])) {
        if (isRoleCheckList(userRoles, [372])) {
            let filteredUserRoles = userRoles.filter(item => item.id === 372);
            let authorizedUnitIds = [];

            filteredUserRoles.forEach(role => {
                if (role.customId !== undefined && role.customId !== null && role.customId !== 0) {
                    authorizedUnitIds.push(role.customId);
                }
            });

            if (authorizedUnitIds.length > 0) {
                return list.filter(item =>
                    authorizedUnitIds.includes(item[idField])
                );
            }
        }
    }

    return list;
};

const getSonSesliHarfi = (kelime) => {
    const kalinSesliler = ['a', 'ı', 'o', 'u'];
    const inceSesliler = ['e', 'i', 'ö', 'ü'];
    let sesHarfi = '';
    for (let i = kelime.length - 1; i >= 0; i--) {
        const harf = kelime.charAt(i).toLowerCase();
        if (kalinSesliler.includes(harf) || inceSesliler.includes(harf)) {
            sesHarfi = harf;
            break;
        }
    }
    return sesHarfi;
};
export function getAddDateSuffix(saat) {


    const kalinSesliler = ['a', 'ı', 'o', 'u'];
    const inceSesliler = ['e', 'i', 'ö', 'ü'];
    const sertUnluler = ['p', 'ç', 't', 'k', 'f', 's', 'ş', 'h'];


    const [saatDegeri, dakikaDegeri] = saat.split('.').map(Number);
    const saatOkunusu = [
        "sıfır", "bir", "iki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz",
        "on", "on bir", "on iki", "on üç", "on dört", "on beş", "on altı", "on yedi",
        "on sekiz", "on dokuz", "yirmi", "yirmi bir", "yirmi iki", "yirmi üç"
    ][saatDegeri];

    const onlar = ["", "on", "yirmi", "otuz", "kırk", "elli"];
    const birler = ["", "bir", "iki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz"];
    let dakikaOkunusu = "";

    const dakikaOndalik = Math.floor(dakikaDegeri / 10);
    const dakikaBirler = dakikaDegeri % 10;

    if (dakikaOndalik > 0) {
        dakikaOkunusu = onlar[dakikaOndalik] + " " + birler[dakikaBirler];
    } else {
        dakikaOkunusu = birler[dakikaBirler];
    }

    const okunacakDeğer = dakikaDegeri === 0 ? String(saatOkunusu) : dakikaOkunusu;
    const sesHarfi = getSonSesliHarfi(okunacakDeğer);


    let ek = '';
    const sonHarf = okunacakDeğer.charAt(okunacakDeğer.length - 1).toLowerCase();

    if (sertUnluler.includes(sonHarf)) {

        if (inceSesliler.some(ince => sesHarfi.includes(ince))) {
            ek = `'te`;
        } else {
            ek = `'ta`;
        }
    } else {

        if (inceSesliler.some(ince => sesHarfi.includes(ince))) {
            ek = `'de`;
        } else {
            ek = `'da`;
        }
    }

    return `${saat}${ek}`;
}

export const mailSmsTextType = [

    {
        id: 1,
        type: "review",
        mailBodyText: "Değerlendirme başlamıştır. Kurulsis ana sayfasından toplantıya erişebilirsiniz.",
        mailTitleText: "Değerlendirme",
        subject: "KURULSİS Değerlendirme | ",
        smsBodyText: "değerlendirmeye açılmıştır.",


    },
    {
        id: 2,
        type: "vote",
        mailBodyText: "Toplantı oylamaya açılmıştır. Kurulsis ana sayfasından toplantıya erişebilirsiniz.",
        mailTitleText: "Oylama",
        subject: "KURULSİS Oylama | ",
        smsBodyText: "oylamaya açılmıştır.",

    },
    {
        id: 3,
        type: "video",
        mailBodyText: " Toplantı, ",
        mailTitleText: "Video Konferans",
        subject: "KURULSİS Video Konferans | ",
        smsBodyText: ", ",
    },
    // {
    //   id: 3,
    //   type: "video",
    //   mailBodyText: "",
    //   mailTitleText: "Video Konferans",
    //   subject: "KURULSİS Video Konferans / ",
    //   smsBodyText: "",
    // },
    {
        id: 4,
        type: "finish",
        mailBodyText: "Toplantı tamamlanmıştır. Kurulsis ana sayfasından toplantıya erişebilirsiniz.",
        mailTitleText: "Tamamlama",
        subject: "KURULSİS Tamamlama | ",
        smsBodyText: "tamamlanmıştır.",

    },
    {
        id: 5,
        type: "agenda",
        mailBodyText: "",
        mailTitleText: "Gündem Listesi",
        subject: "KURULSİS | ",
        smsBodyText: "nın gündem listesi eposta olarak gönderilmiştir.",

    },
    {
        id: 6,
        type: "decision",
        mailBodyText: "",
        mailTitleText: "Karar Listesi",
        subject: "KURULSİS | ",
        smsBodyText: "nın karar listesi eposta olarak gönderilmiştir.",

    },
    {
        id: 7,
        type: "agendaDecision",
        mailBodyText: "",
        mailTitleText: "Gündem Listesi",
        subject: "KURULSİS | ",
        smsBodyText: "nın gündem ve karar listeleri eposta olarak gönderilmiştir.",

    }
]

